import { c as _c } from "react/compiler-runtime";
import { RefObject } from 'react';
import Box from '@classify/react-core-components/Box';
import { styled } from '@classify/react-core-components/styles';
import type { Theme } from '@classify/react-core-components/styles';
import EmbeddedChapterFooter from './EmbeddedChapterFooter';
import type { CompletionState, EmbeddedChapterTranslations } from '../../../types';
const ContentRoot = styled(Box)(({
  theme
}: {
  theme: Theme;
}) => ({
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  paddingTop: theme.spacing(1),
  paddingBottom: 0
}));
type EmbeddedChapterContentProps = {
  chapterContent: string;
  chapterContentRef: RefObject<HTMLDivElement | null>;
  completionState: CompletionState;
  onMarkAsComplete: () => void;
  translations: EmbeddedChapterTranslations;
};

/**
 * @param chapterContent - HTML string (CLAIRE-rendered)
 * @param chapterContentRef - ref to ContentRoot; passed to parent for DOM post-processing/parsing.
 *        Without this ref, the parser service cannot access the rendered DOM nodes to enhance content.
 * @param completionState - 'idle' | 'loading' | 'completed' | 'error'
 * @param onMarkAsComplete - callback when user clicks validate button
 */
const EmbeddedChapterContent = t0 => {
  const $ = _c(12);
  const {
    chapterContent,
    chapterContentRef,
    completionState,
    onMarkAsComplete,
    translations
  } = t0;
  let t1;
  if ($[0] !== chapterContent) {
    t1 = {
      __html: chapterContent
    };
    $[0] = chapterContent;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== chapterContentRef || $[3] !== t1) {
    t2 = <ContentRoot ref={chapterContentRef} className="oc-richContent" data-chapter-inline-content="true" dangerouslySetInnerHTML={t1} />;
    $[2] = chapterContentRef;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== completionState || $[6] !== onMarkAsComplete || $[7] !== translations) {
    t3 = <EmbeddedChapterFooter completionState={completionState} onMarkAsComplete={onMarkAsComplete} translations={translations} />;
    $[5] = completionState;
    $[6] = onMarkAsComplete;
    $[7] = translations;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default EmbeddedChapterContent;